import { render, staticRenderFns } from "./RenewPolicy.vue?vue&type=template&id=490da2d2"
import script from "./RenewPolicy.vue?vue&type=script&lang=js"
export * from "./RenewPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports